import React, { useState } from "react";

interface Props {
  message: string;
}

const NoticeCard: React.FC<Props> = ({ message }) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = message.length > 300;
  const displayMessage =
    isLong && !expanded ? message.substring(0, 300) + "..." : message;

  return (
    <div className="pc-card pc-notice">
      <div className="pc-notice-content">
        <div
          className="pc-notice-text"
          dangerouslySetInnerHTML={{ __html: displayMessage }}
        />
        {isLong && (
          <button
            type="button"
            className="pc-link-btn"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? "Show less" : "Show more"}
            <i
              className={`fas fa-chevron-${expanded ? "up" : "down"} pc-ml-xs`}
            ></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default NoticeCard;
